export default {
  addChannels: 'Add the channels you want to manage from keybe',
  channelActive: 'Channel active',
  channelInactive: 'Channel inactive',
  addChatToWebsite: 'Add a chat widget to your website',
  channels: 'Channels',
  scriptCopied: 'Script copied',
  errorCopying: 'Error copying',
  connectChannel: 'Connect',
  extendConnection: 'Extend',
  continue: 'Continue',
  facebookConnected: 'Facebook connected',
  instagramConnected: 'Instagram connected',
  selectPage: 'Select page',
  whatsappAppId: 'Whatsapp App Id',
  whatsappAppKey: 'Whatsapp App Key',
  whatsappSecretId: 'Whatsapp Secret Id',
  whatsappIntegrationId: 'Whatsapp Integration Id',
  namespace: 'Namespace',
  setProvider: 'Set as provider',
  whatsappAppName: 'App name',
  whatsappApiKey: 'API key',
  enable: 'Enable',
  channelId: 'Channel Id',
  gupshup_wp: 'Gupshup',
  smooch_wp: 'Smooch',
  hibot_wp: 'Hibot',
  provider: 'Provider',
  initSesionFacebook: 'Init session with facebook',
  extendSesionFacebook: 'Extend facebook session',
  initSesionInstagram: 'Init session with instagram',
  extendSesionInstagram: 'Extend instagram session',
  finalStepSocial: 'You are one step away from connecting your channels',
  goToApp: 'Go to app',
  continueSocial: 'Continue with',
  connectKbLine: 'Connect a Keybe line',
  facebookWillBeDisconnected: 'Your facebook channel will be disconnected at ',
  instagramWillBeDisconnected: 'Your instagram channel will be disconnected at ',
  facebookIsDisconnected: 'Your facebook channel is disconnected',
  instagramIsDisconnected: 'Your Instagram channel is disconnected',
  facebookDisconnected: 'Facebook disconnected',
  dueToPolicies: 'Due to policies of ',
  metaInc: 'Meta Platforms Inc.',
  channelDisconnectionDesc: 'we must ask you from time to time if you want to continue using your meta accounts with Keybe, you just have to ',
  extendTime: 'Accept to extend the term',
  channelDisconnectionDesc2: 'and we take care of the rest',
  sureToDisconnect: 'Are you sure you don\'t want to extend the deadline?',
  sureToDisconnectInstagram: 'You will lose the connection of your instagram channel with Keybe',
  sureToDisconnectFacebook: 'You will lose the connection of your facebook channel with Keybe ',
  loseConnection: 'Lose connection',
  goToPage: 'Go to page'
}
